import { Component, OnInit } from '@angular/core';
import { RouterService } from 'src/app/services/router/router.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-term-link',
  templateUrl: './term-link.component.html',
  styleUrls: ['./term-link.component.scss']
})
export class TermLinkComponent implements OnInit {

  webUrl = environment.webUrl;

  constructor(private routerService: RouterService) { }

  ngOnInit(): void {
  }

  navigateToTerms(type: 'service' | 'personal'): void {
    this.routerService.navigate(`terms/${type}`);
  }
}
